var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.96 283.77C220.306 283.77 283.818 220.258 283.818 141.912C283.818 63.566 220.306 0.053833 141.96 0.053833C63.6142 0.053833 0.102051 63.566 0.102051 141.912C0.102051 220.258 63.6142 283.77 141.96 283.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.96 283.77C220.306 283.77 283.818 220.258 283.818 141.912C283.818 63.566 220.306 0.053833 141.96 0.053833C63.6142 0.053833 0.102051 63.566 0.102051 141.912C0.102051 220.258 63.6142 283.77 141.96 283.77Z",
    fill: "#E4251F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.96 258.636C206.425 258.636 258.684 206.377 258.684 141.912C258.684 77.4471 206.425 25.1882 141.96 25.1882C77.4952 25.1882 25.2363 77.4471 25.2363 141.912C25.2363 206.377 77.4952 258.636 141.96 258.636Z",
    fill: "#E4251F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.96 226.272C151.337 226.272 158.938 218.671 158.938 209.295C158.938 199.918 151.337 192.317 141.96 192.317C132.584 192.317 124.983 199.918 124.983 209.295C124.983 218.671 132.584 226.272 141.96 226.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.719 177.482C132.476 177.482 124.98 169.986 124.98 160.742V74.2883C124.98 65.0449 132.476 57.5491 141.719 57.5491C150.963 57.5491 158.458 65.0449 158.458 74.2883V160.742C158.458 169.986 150.963 177.482 141.719 177.482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 284,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.1459634507715e97f8acad44f3f501ec.svg";
export { ForwardRef as ReactComponent };